// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get } from "./api_client";
import { SimOperatorInfo, ISimOperatorInfo } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getSimOperatorName(operatorCode?: string): ApiResult<SimOperatorInfo> {
	return get<ISimOperatorInfo>(`/api/simoperator/${ operatorCode }`).then(result => result === undefined ? undefined :  new SimOperatorInfo(result));
}
